export const projects = [
  {
    link: "scrolls_and_scribbles",
    title: "Scrolls & Scribbles",
    small_desc: "Note taking app",
    tags: ["Vue", "Javascript"],
    website: {
      link: "https://scrolls-and-scribbles.vercel.app/",
      desc: "Start taking notes now!",
    },
    github: "https://github.com/JDSalisbury/scrolls_scribbles",
    img: "s&s.png",
    thumb: "s&s_t.png",
    larg_desc:
      "Created an app to take notes to help play D&D online with friends. Didn't want to get too complicated so currently saving data to a txt file, and allowing users to upload said txt file. Future itterations will involve the ability to add your own tab layout, encrypting the txt files saved notes, and possibly adding a lil pizzaz.",
  },
  {
    link: "draft_value",
    title: "MTGA Draft Value",
    small_desc: "Javascript Scrape and value MTGA exported draft.",
    tags: ["Express", "Cheerio", "Javascript", "Scripting"],
    website: {},
    github: "https://github.com/JDSalisbury/scrape-time",
    img: "mtg.png",
    thumb: "mtg_t.png",
    larg_desc:
      "Using a generic express setup up. Created a web scraper and stole some info off the web. Using that info to find the value of Mtg arena exported list. The info is then being gathered to judge my ability to draft, and if a higher valued deck does better than a lower one. More info in the github readme.",
  },
  {
    link: "blog",
    img: "pp5.png",
    title: "Blog",
    small_desc: "Blog Site for blogging things.",
    tags: ["Vue", "Vuex", "DRF", "Django", "Python", "AWS", "Docker", "Mongo"],
    website: {},
    github: "https://github.com/JDSalisbury/blogit",
    thumb: "pp5.png",
    larg_desc:
      "Using Vue and Vuex I implimented a small blog site. I don't know if I am the blogging type but I wanted to get a full webiste up and running with AWS running a docker container with my DRF API and using Django admin as a CMS. The DB is Mongo Atlas. This site is bringing together some of the fullstack webdev tools and skills I've learned.",
  },
  {
    link: "familiar",
    title: "Familiar",
    small_desc: "D&D Character sheet Manager",
    tags: ["Vue", "Vuex", "Django", "Python", "MySQL", "Docker"],
    website: {},
    github: "https://github.com/JDSalisbury/familiar",
    img: "familiar.png",
    thumb: "familiar.png",
    larg_desc:
      "Creating a web application to manage D&D Character sheets. Currently this is focused on creating characters for Gamma World 4th edition. The application randomly generates 3 character choices at a time by pulling 75 random classes/races together. You can then manage the character adding equipment skills and abilities as you increase in level.",
  },
  {
    link: "pantry_plus",
    title: "Pantry Plus",
    small_desc: "Food Pantry shopping cart application for curbside pickups",
    tags: [
      "Java",
      "Thymeleaf",
      "Spring",
      "JavaScript",
      "HTML/CSS",
      "JPA",
      "AJAX",
      "Agile",
      "Heroku",
      "Travis CI",
      "Coveralls",
      "TDD",
    ],
    website: {
      link: "http://pantryplus.herokuapp.com/",
      desc: "Broad St. Food Pantry App",
    },
    github: "https://github.com/NAPOSCA/pantryplus",
    img: "pantry_plus.png",
    thumb: "pantry_plus.png",
    larg_desc:
      "Constructed a curb-side pick up application for The Broad St. Food Pantry. The Broad St. Food Pantry was unable to service some of there clients due to the hour long wait time. Our goal was to reduce the wait time to ten minutes so that people with children or people who dont have a secure form of transportion can quickly come in and get their food. Through TDD and Pair programing my team of six was able to get the wait time down to seven minutes. This application is currently in operation and is assisting 150+ patrons.",
  },
  {
    link: "ims",
    title: "IMS",
    img: "IMS.png",
    small_desc: "Inventory Management System",
    tags: ["Java", "JavaScript", "Html/CSS", "H2 Database", "Spring Boot"],
    website: {},
    github: "https://github.com/JDSalisbury/ims",
    thumb: "IMS.png",
    larg_desc:
      "Full-Stack Inventory Managment System. Created to help 'Fresh Time' Food Market keep track of there produce, and expiration dates. There old system was with pen and paper.",
  },
  {
    link: "sage",
    title: "Sage",
    img: "sage.png",
    small_desc: "Cat",
    tags: ["Willpower", "Diligence", "Determination"],
    website: {
      link: "https://www.instagram.com/sage_meows/",
      desc: "She has an Instagram...",
    },
    thumb: "sage_t.png",
    larg_desc:
      "Cat owner. It takes a lot to own one of these creatures. I've successfully kept this small beast alive for about a two years now. The struggle is real. She barely cares about me.",
  },
  {
    link: "pmdr",
    title: "Pomodoro Timer",
    img: "pmdr.png",
    small_desc: "CLI Pomodoro Timer for development",
    tags: ["CLI", "Python", "Scripting", "Guitar"],
    website: {
      link: "https://pypi.org/project/Pmdr/",
      desc: "Pip install today!",
    },
    github: "https://github.com/JDSalisbury/doro",
    thumb: "pmdr.png",
    larg_desc:
      "Created A Pomodor style CLI tool. Option break times and lengths. Included a reqular timer and 30min - 1hr quick timer. Also created and recorded the alarm sounds.",
  },
  {
    link: "tacticas",
    title: "Tacticas",
    img: "TacticAs.jpg",
    small_desc: "Boardgame",
    tags: ["Hexo", "JavaScript", "Markdown", "Vercel"],
    website: {
      link: "https://hexo-cw7nbe1k0.vercel.app/",
      desc: "Rulebook Site",
    },
    github: "https://github.com/JDSalisbury/hexo_tas",
    thumb: "tacticas_t.png",
    larg_desc:
      "A board game for Champions! Command a team of Units, equip them as you see fit, and do battle against your friends. 2-4 players. This game is similar to HeroClix and Final Fantasy Tactics. A minitures game all in one box with one affordable price!  Created Rulebook with Vercel using Hexo template, markdow, and javascript.",
  },
];
